import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-dark-800 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-lime-400/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-lavender-400/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
          {t('cta.title')}
        </h2>
        <p className="text-xl text-white/70 mb-10 max-w-2xl mx-auto">
          {t('cta.subtitle')}
        </p>

        <div className="flex items-center justify-center">
          <a href="#waitlist">
            <Button
              variant="primary"
              size="lg"
              rightIcon={<ArrowRight className="w-5 h-5" />}
            >
              {t('waitlist.joinButton')}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
